const { store } = require("Redux/store");
const { fetchGet, callAPIAlumni } = require("./api");

export const updateInformationsToWS = async (isCharte, forcedBody = null) => {
    const user = store.getState().auth.userConnected;
    const token = store.getState().auth.token;

    if (!user || !token) return;

    try {
        // Récupérations des informations détaillées du user
        const fullUser = await fetchGet(`/users/${user.id}/private`, token);

        // On stocke les infos de base
        const body = forcedBody || {
            givenName: fullUser.firstname,
            sn: fullUser.surname,
            supannOIDCDateDeNaissance: fullUser.birthday.split("T")[0],
            pager: fullUser.telephone,
            supannMailPerso: fullUser.email,
        };

        // Ajout de la charte
        body.supannConsentement = isCharte;

        // Si l'utilisateur n'a pas d'education on return
        if (!fullUser?.resume?.educations?.length > 0) return;

        // Sinon on récupère tous ses supannExtProfil
        const supannExtProfil = [];
        fullUser.resume.educations.forEach((x) => {
            if (x.obtainedDiplome) {
                const annee = x.endDate.split("-")[0];
                supannExtProfil.push({
                    supannCodePopulation: "{SUPANN}PXAD",
                    supannEtuDiplome: "{SISE}" + x.obtainedDiplome.codeSize,
                    supannEtuAnneeInscription: annee,
                });
            }
        });

        // Si pas de supannExtProfil on return
        if (supannExtProfil.length === 0) return;
        // Sinon on l'ajoute
        body.supannExtProfil = supannExtProfil;

        // Si pas de eduPersonPrincipalName on return
        if (!fullUser.eduPersonPrincipalName) return;
        // Sinon on l'ajoute
        body.eduPersonPrincipalName = fullUser.eduPersonPrincipalName;

        // On ajoute soit le supannRefId (user venant d'une validation manuelle) soit le supannEtuId, ou on return
        if (fullUser.supannRefId) {
            body.supannRefId = fullUser.supannRefId;
        } else if (fullUser.supannEtuId) {
            body.supannEtuId = fullUser.supannEtuId;
        } else return;

        // Appel vers l'API Alumni
        callAPIAlumni("/update_informations", body);
    } catch (error) {
        return;
    }
};
